import { env } from '../config/environment';

export const FORGOT_PASSWORD_SUCCESS_MESSAGE =
  'If an account exists for that email address, we have sent a password reset link. The link expires in one hour. You can request another reset from this page.';

/**
 * Request a password reset email (public login flow).
 * Always returns a generic success message when the request is accepted.
 * @param {string} email
 */
export async function requestForgotPassword(email) {
  const response = await fetch(env.apiEndpoints.forgotPassword, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: (email || '').trim() }),
  });
  const data = await response.json().catch(() => ({}));

  if (response.status === 429) {
    throw new Error(
      data.error || 'Too many reset requests. Please wait and try again later.'
    );
  }

  if (!response.ok) {
    throw new Error(data.error || 'Unable to send reset email. Please try again later.');
  }

  return data.message || FORGOT_PASSWORD_SUCCESS_MESSAGE;
}
